import { motion } from "framer-motion";
import { MotionUtils } from "app/utils/motionUtils";

export default function AuthProtectorLoading({ message }: Readonly<{ message: string; }>) {

  return (
    <>
      <header id="header">
        <div className="header-wrap">
          <div className="side-wrap">
            <h1 className="logo">
              <span className="hid">e.CLOUD</span>
            </h1>
          </div>
        </div>

        <div className="hdt-link">
          <div className="ht-tit">
            <h1 className="logo">
              <span className="hid">e.CLOUD</span>
            </h1>
          </div>
        </div>
      </header>

      <div id="container">
        <div id="sub_container">
          <div id="contents">
            <div className="container">
              <div className="sub-wrap">
                <motion.div className="n-overlay auth show" variants={MotionUtils.overlay}>
                  <div className="n-ol-inner1">
                    <p className="icon">
                      <i className="xi-spinner-5 xi-spin"></i>
                    </p>
                    <p className="txt fs18">{message}</p>
                    <p className="txt fs18">잠시만 기다려주세요.</p>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}